import React, { useState } from "react";
import "../../styles/UploadAdImage.css";
import { API_BASE_URL } from "../../config";

export default function UploadAdImage({ refreshAds }) {
  const [imageFile, setImageFile] = useState(null);
  const [advertisementName, setAdvertisementName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyUrl, setCompanyUrl] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");

    if (!imageFile) {
      setMessage("Please select an image.");
      setSubmitting(false);
      return;
    }

    let adName = advertisementName;
    if (!adName) {
      adName = "New Untitled Ad";
    }

    const formData = new FormData();
    formData.append("image", imageFile);
    formData.append("advertisement_name", adName);
    formData.append("company_name", companyName);
    formData.append("company_url", companyUrl);
    formData.append("description", description);

    try {
      const res = await fetch(`${API_BASE_URL}/api/ads/upload_with_metadata`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("Image and metadata uploaded!");
        setAdvertisementName("");
        setCompanyName("");
        setCompanyUrl("");
        setDescription("");
        setImageFile(null);
        if (refreshAds) refreshAds();
      } else {
        setMessage(data.message || "Upload failed.");
      }
    } catch {
      setMessage("Upload failed.");
    }
    setSubmitting(false);
  };

  return (
    <div className="upload-ad-container">
      <h2 className="upload-ad-title">Upload Advertisement Image</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 18 }}>
          <label className="upload-ad-label">Image (.jpg/.png, &lt;5MB):</label>
          <input
            type="file"
            accept="image/png,image/jpeg"
            onChange={e => setImageFile(e.target.files[0])}
            required
            className="upload-ad-input"
          />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label className="upload-ad-label">Advertisement Name:</label>
          <input
            type="text"
            value={advertisementName}
            onChange={e => setAdvertisementName(e.target.value)}
            className="upload-ad-input"
            placeholder="New Untitled Ad"
          />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label className="upload-ad-label">Company Name:</label>
          <input
            type="text"
            value={companyName}
            onChange={e => setCompanyName(e.target.value)}
            className="upload-ad-input"
          />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label className="upload-ad-label">Company URL:</label>
          <input
            type="url"
            value={companyUrl}
            onChange={e => setCompanyUrl(e.target.value)}
            className="upload-ad-input"
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label className="upload-ad-label">Description:</label>
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            className="upload-ad-textarea"
          />
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="upload-ad-btn"
        >
          {submitting ? "Uploading..." : "Upload"}
        </button>
      </form>
      {message && (
        <div className="upload-ad-message">
          {message}
        </div>
      )}
    </div>
  );
}